import {
  ChangeEvent,
  CmsModel,
  CmsModelEntry,
  CmsWebsiteBM,
  CmsWebsiteConfigBM,
  FileEntryBM,
} from '@bm-js/atlascloud-shared'
import { createContext } from 'react'

export interface CmsEditorBackendResponse {
  website: CmsWebsiteBM
  websiteConfig: CmsWebsiteConfigBM
  isPublished: boolean
}

export interface CmsEditorState {
  editorData?: {
    backendResponse: Omit<CmsEditorBackendResponse, 'websiteConfig'>
    workingConfig: CmsWebsiteConfigBM
    activeModel: CmsModel | null
    activeEntry: CmsModelEntry | null
  }

  actions: {
    saveConfig: () => Promise<void>
    publishConfig: () => Promise<void>
    patchConfig: (updatedConfig: Partial<CmsWebsiteConfigBM>) => void
    openEntry: (model: CmsModel, entry: CmsModelEntry) => void
    handleFieldChange: (
      fieldIndex: number,
      e: ChangeEvent<FileEntryBM | string | string[]>
    ) => void
  }
  status: {
    isLoading: boolean
    isError: boolean
    isSaved: boolean
    isSaving: boolean
    isPublished: boolean
    isPublishing: boolean
  }
}

export const CmsEditorContext = createContext<CmsEditorState>({
  actions: {
    saveConfig: () => Promise.resolve(),
    publishConfig: () => Promise.resolve(),
    patchConfig: () => {},
    openEntry: () => {},
    handleFieldChange: () => {},
  },
  status: {
    isError: false,
    isLoading: false,
    isSaved: false,
    isSaving: false,
    isPublished: false,
    isPublishing: false,
  },
})
